import { gql } from '@apollo/client';

export const SET_DEFAULT_ROUTE_PLANNING_TEMPLATE = gql`
    mutation SetDefaultRoutePlanningTemplate($id: Long!, $areaId: Long!, $warehouseId: Long!) {
        setDefaultRoutePlanningTemplate(id: $id, areaId: $areaId, warehouseId: $warehouseId)
    }
`;

export interface SetDefaultRoutePlanningTemplateResponse {
    setDefaultRoutePlanningTemplate: boolean;
}

export interface SetDefaultRoutePlanningTemplateVariables {
    id: number;
    areaId: number;
    warehouseId: number;
}
